import { render } from "./SignUpComponent.vue?vue&type=template&id=681d0978"
import script from "./SignUpComponent.vue?vue&type=script&lang=js"
export * from "./SignUpComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\_Hamza\\_Code\\HealthAcademy\\SCFHSHealthAcademyPublic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__